import gql from 'graphql-tag';

import credentialFragment from '../fragments/credentialFragment';

export const mutationUpdateCredentialOAuth = gql`
  mutation updateCredentialOAuth (
    $code: String!
    $credentialID: DokkioID!
    $redirectURI: String!
  ) {
    updateCredentialOAuth (
      code: $code
      credentialID: $credentialID
      redirectURI: $redirectURI
    ) {
      ...credentialFragment
    }
  }
  ${credentialFragment}
`;
export default mutationUpdateCredentialOAuth;
